import React from "react";

export const Stat = ({ label, value, tone = "default" }) => {
  const tones = {
    default: "border-slate-200 bg-white",
    good: "border-emerald-200 bg-emerald-50",
    warn: "border-amber-200 bg-amber-50",
    info: "border-nmi-200 bg-nmi-50",
  };
  return (
    <div className={`rounded-md border ${tones[tone]} p-4`}>
      <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">{label}</div>
      <div className="mt-1 font-heading text-2xl font-bold text-slate-900">{value}</div>
    </div>
  );
};
